const employeeRangesOptions = [
    {label: "1 a 10 funcionários", value: "1-10"},
    {label: "11 a 50 funcionários", value: "11-50"},
    {label: "51 a 100 funcionários", value: "51-100"},
    {label: "101 a 500 funcionários", value: "101-500"},
    {label: "501 a 1.000 funcionários", value: "501-1000"},
    {label: "+ de 1.000 funcionários", value: "1000+"}
];

export default employeeRangesOptions;